import { useEffect } from 'react';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';
import { useAdaptiveLayout } from './useAdaptiveLayout';

export const useBodyScrollLock = (active: boolean) => {
  const { isTablet } = useAdaptiveLayout();

  useEffect(() => {
    const body = document.body;

    if (active && !isTablet) {
      disableBodyScroll(body);
      body.style.paddingRight = '10px';
    } else {
      enableBodyScroll(body);
      body.style.paddingRight = '';
    }

    return () => {
      enableBodyScroll(body);
      clearAllBodyScrollLocks();
    };
  }, [active, isTablet]);
};
